import React, { useCallback, useRef } from 'react';

import { Button, TextSearchReplace } from '..';
import { Modal } from '../Modal';
import { DnDTip } from '../TextSearchReplace/components';

export type EditorModalProps = {
  initialContent: string;
  isLibraryMode: boolean;
  onClose: () => void;
  onSave: (content: string) => void;
};

export const EditorModal: React.FC<EditorModalProps> = ({
  initialContent,
  onClose,
  onSave,
  isLibraryMode,
}) => {
  const editorRef = useRef<HTMLDivElement>(
    null
  ) as React.RefObject<HTMLDivElement>;

  const handleSave = useCallback(() => {
    if (editorRef.current) {
      onSave(editorRef.current.innerText);
    }
    onClose();
  }, [onSave, onClose]);

  return (
    <Modal title="Edit Content" size="big" open onClose={onClose}>
      <div className="flex flex-col gap-sm h-full">
        <TextSearchReplace
          editorRef={editorRef}
          initialContent={initialContent}
          isLibraryMode={isLibraryMode}
        />
        <div className="flex items-center w-full justify-between gap-x-4 mt-2">
          {isLibraryMode && <DnDTip />}
          <div className="flex gap-x-4 ">
            <Button
              size="medium"
              type="contrast"
              label="Cancel"
              className="text-main flex-1 min-w-0"
              onClick={onClose}
            />
            <Button
              size="medium"
              label="Save"
              className="flex-1 min-w-0"
              onClick={handleSave}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
